import { ReactNode } from 'react';

import cx from 'classnames';

import { InputMessage } from './InputMessage';
import { LengthCounter, Expander } from '../common';
import { TInputBaseProps } from './InputTypes';

export type TCommonInputProps = TInputBaseProps & {
  isHidden?: boolean;
  isMessagesRemoved?: boolean;
  classes?: TInputBaseProps['classes'] & { message: string };
  messages?: ReactNode;
};

// Function for rendering messages
export const renderMessages = (
  props: TCommonInputProps & { valueLength?: number },
  isTextarea = false,
) => {
  const { messages, classes, status, maxLength, valueLength } = props;

  if (isTextarea && maxLength) {
    return (
      <div className="flex justify-between items-center gap-2">
        <InputMessage className={cx(classes?.message)} status={status}>
          {messages}
        </InputMessage>
        <Expander />
        <LengthCounter
          className="text-sm"
          length={valueLength || 0}
          maxLength={maxLength}
        />
      </div>
    );
  }

  return (
    <InputMessage className={cx(classes?.message)} status={status}>
      {messages}
    </InputMessage>
  );
};
